// Simple MSP type utilities
// Replace hardcoded msp_id === 3 checks with msp_type checks

/**
 * Check if MSP type is NinjaOne
 */
export const isNinjaOne = (mspType: string): boolean => {
  return mspType === "ninjaone";
};

/**
 * Check if MSP type is SuperOps
 */
export const isSuperOps = (mspType: string): boolean => {
  return mspType === "superops";
};

/**
 * Check if MSP type is Autotask
 */
export const isAutotask = (mspType: string): boolean => {
  return mspType === "autotask";
};

/**
 * Check if MSP type is Halo
 */
export const isHalo = (mspType: string): boolean => {
  return mspType === "halo";
};

/**
 * Check if MSP type is ConnectWise
 */
export const isConnectWise = (mspType: string): boolean => {
  return mspType === "connectwise";
};

const PSA_DISPLAY_NAMES: Record<string, string> = {
  autotask: "Autotask",
  connectwise: "ConnectWise",
  halo: "Halo",
  superops: "SuperOps",
  ninjaone: "NinjaOne",
};

/**
 * Product name for a PSA source or msp_type ("autotask" => "Autotask"); "PSA" when unknown.
 */
export const getPsaDisplayName = (source?: string | null): string => {
  const normalized = String(source || "").trim().toLowerCase();
  return PSA_DISPLAY_NAMES[normalized] ?? "PSA";
};

/**
 * Ticket scope label by PSA platform
 * Autotask/SuperOps => Queue, ConnectWise/NinjaOne => Board, Halo => Team
 */
export const getTicketScopeLabel = (mspType?: string | null): "Queue" | "Board" | "Team" => {
  const normalized = String(mspType || "").toLowerCase();
  if (normalized === "connectwise" || normalized === "ninjaone") {
    return "Board";
  }
  if (normalized === "halo") {
    return "Team";
  }
  return "Queue";
};

/**
 * Plural ticket scope label by PSA platform
 */
export const getTicketScopeLabelPlural = (
  mspType?: string | null
): "Queues" | "Boards" | "Teams" => {
  const singular = getTicketScopeLabel(mspType);
  if (singular === "Board") {
    return "Boards";
  }
  if (singular === "Team") {
    return "Teams";
  }
  return "Queues";
};

/**
 * Category scope label by PSA platform
 * Halo => Ticket Type(s), others => Category/Categories
 */
export const getCategoryScopeLabel = (
  mspType?: string | null
): "Category" | "Ticket Type" => {
  const normalized = String(mspType || "").toLowerCase();
  if (normalized === "halo") {
    return "Ticket Type";
  }
  return "Category";
};

export const getCategoryScopeLabelPlural = (
  mspType?: string | null
): "Categories" | "Ticket Types" => {
  const singular = getCategoryScopeLabel(mspType);
  if (singular === "Ticket Type") {
    return "Ticket Types";
  }
  return "Categories";
};
